import { useContext } from "react";
import TrackerContext from "../app/TrackerContext";

export default function () {
  return useContext(TrackerContext);
}
